module.exports = __webpack_public_path__ + "img/notification-icon.d9a5ffa8.svg";